import {
  Box,
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from "@mui/material";
import { useState } from "react";
import { seniorSecondaryBoards } from "./Fixed Data/MappingsFor11thand12th";
import apiClient from "../../../utils/apiClient";
import { useEffect } from "react";

const SchoolingStep1112 = ({ data, setData, handleNext, handleBack }) => {
  useEffect(() => {
    const fetchSchooling1112 = async () => {
      try {
        const res = await apiClient.get("/counselling/schooling-11-12");
        const apiData = res.data?.data;

        if (!apiData) return;

        setData((prev) => ({
          ...prev,

          // 🔹 Direct JSON hydration
          selectedClasses: apiData.selectedClasses || "",
          stream: apiData.stream || "",
          grading: apiData.grading || "",

          school11: apiData.school11 || "",
          board11: apiData.board11 || "",

          school12: apiData.school12 || "",
          board12: apiData.board12 || "",

          subjects: apiData.subjects || [],
          other_subject: apiData.other_subject || "",

          marks: apiData.marks || {},
        }));

        // 🔹 Auto step handling
        if (apiData.selectedClasses === "both") {
          setCurrentStep("11");
        }
      } catch (err) {
        console.error("Failed to fetch schooling 11-12 data", err);
      }
    };

    fetchSchooling1112();
  }, [setData]);
  // useEffect(() => {
  //   if (
  //     data.school11 &&
  //     data.school11 === data.school12 &&
  //     data.board11 === data.board12
  //   ) {
  //     setSameAs11(true);
  //   }
  // }, [data.school11, data.school12, data.board11, data.board12]);

  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState("11"); // "11" | "12"
  const [sameAs11, setSameAs11] = useState(false);

  const schoolBoards = Object.keys(seniorSecondaryBoards);
  const [streams, setStreams] = useState(
    data.board11 ? Object.keys(seniorSecondaryBoards[data.board11]) : [],
  );

  const gradingOptions = ["Percentage", "CGPA (10 Scale)", "Grades"];
  const subjectsList =
    data.board11 && data.stream
      ? seniorSecondaryBoards[data.board11][data.stream]
      : [];

  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
    mb: 3,
  };

  const toggleSubject = (subject) => {
    let updated = [...(data.subjects || [])];
    if (updated.includes(subject)) {
      updated = updated.filter((s) => s !== subject);
    } else {
      updated.push(subject);
    }
    setData({ ...data, subjects: updated });
  };

  const handleMarksChange = (classKey, subject, value) => {
    setData({
      ...data,
      marks: {
        ...(data.marks || {}),
        [classKey]: {
          ...(data.marks?.[classKey] || {}),
          [subject]: value,
        },
      },
    });
  };

  const getMarksOptions = () => {
    if (data.grading === "Percentage") {
      return [
        "Not applicable",
        "30-40%",
        "40-50%",
        "50-60%",
        "60-70%",
        "70-80%",
        "80-90%",
        "Above 90%",
      ];
    }
    if (data.grading === "CGPA (10 Scale)") {
      return ["Not applicable", "1 - 3", "3 - 5", "5 - 7", "7 - 9", "9 - 10"];
    }
    if (data.grading === "Grades") {
      return ["Not applicable", "A+", "A", "B+", "B", "C", "D", "E"];
    }
    return ["Not applicable"];
  };

  const selectedClasses = data.selectedClasses || "";

  // ---------------- VALIDATION ----------------
  const validate = () => {
    let temp = {};

    if (!selectedClasses) temp.selectedClasses = "Required";

    if (["11", "both"].includes(selectedClasses)) {
      if (!data.school11) temp.school11 = "Required";
      if (!data.board11) temp.board11 = "Required";
    }

    if (["12", "both"].includes(selectedClasses)) {
      if (!data.school12) temp.school12 = "Required";
      if (!data.board12) temp.board12 = "Required";
    }

    if (!data.stream) temp.stream = "Stream is required";

    // grading required
    if (!data.grading) temp.grading = "Required";

    // subjects
    if (!data.subjects || data.subjects.length === 0) {
      temp.subjects = "Select at least 1 subject";
    }

    // other subject required if "Others" selected
    if (data.subjects?.includes("Others") && !data.other_subject) {
      temp.other_subject = "Required";
    }

    // marks validation
    if (["11", "both"].includes(selectedClasses)) {
      subjectsList
        .filter((s) => data.subjects?.includes(s))
        .forEach((subject) => {
          if (!data.marks?.["11"]?.[subject]) {
            temp[`marks11_${subject}`] = "Required";
          }
        });
    }

    if (["12", "both"].includes(selectedClasses)) {
      subjectsList
        .filter((s) => data.subjects?.includes(s))
        .forEach((subject) => {
          if (!data.marks?.["12"]?.[subject]) {
            temp[`marks12_${subject}`] = "Required";
          }
        });
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleNextClick = async (data) => {
    if (validate()) {
      await apiClient.post("/counselling/schooling-11-12", {
        schoolingData: data,
      });
      onNext();
    } else {
      alert("Please fill information properly");
    }
  };

  const onNext = () => {
    handleNext();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "22px", sm: "24px", md: "28px" },
          fontWeight: 600,
          mb: 1,
        }}
      >
        Schooling Information (11th + 12th)
      </Typography>

      {/* CLASS SELECT */}
      <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 1 }}>
        Select Your Current Class*
      </Typography>

      <FormControl fullWidth error={!!errors.selectedClasses}>
        <Select
          displayEmpty
          sx={uiFieldStyles}
          value={selectedClasses}
          onChange={(e) =>
            setData({ ...data, selectedClasses: e.target.value })
          }
        >
          <MenuItem value="" disabled>
            Select Class
          </MenuItem>
          {/* <MenuItem value="11">Only Class 11th</MenuItem> */}
          {/* <MenuItem value="12">Only Class 12th</MenuItem> */}
          <MenuItem value="both">Both 11th & 12th</MenuItem>
        </Select>
        {errors.selectedClasses && (
          <FormHelperText>{errors.selectedClasses}</FormHelperText>
        )}
      </FormControl>

      {/* ---------------- CLASS 11 ---------------- */}
      {["11"].includes(selectedClasses) && (
        <Box sx={{ mb: 6 }}>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 3 }}>
            Class 11th
          </Typography>

          <Grid container spacing={3}>
            {/* School Name */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Name*
              </Typography>
              <TextField
                fullWidth
                error={!!errors.school11}
                helperText={errors.school11}
                placeholder="School Name"
                sx={uiFieldStyles}
                value={data.school11 || ""}
                onChange={(e) => setData({ ...data, school11: e.target.value })}
              />
            </Grid>

            {/* Board */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Board*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.board11}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.board11 || ""}
                  onChange={(e) =>
                    setData({ ...data, board11: e.target.value, stream: "" })
                  }
                >
                  <MenuItem value="" disabled>
                    Select Board
                  </MenuItem>
                  {schoolBoards.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                {errors.board11 && (
                  <FormHelperText>{errors.board11}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Stream*
              </Typography>
              <FormControl fullWidth sx={uiFieldStyles} error={!!errors.stream}>
                <Select
                  displayEmpty
                  value={data.stream || ""}
                  onChange={(e) => setData({ ...data, stream: e.target.value })}
                >
                  <MenuItem value="" disabled>
                    Select Stream
                  </MenuItem>
                  {streams.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.stream}</FormHelperText>
              </FormControl>
            </Grid>

            {/* Grading */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Grading System*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.grading}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.grading || ""}
                  onChange={(e) =>
                    setData({ ...data, grading: e.target.value })
                  }
                >
                  <MenuItem value="" disabled>
                    Choose option
                  </MenuItem>
                  {gradingOptions.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
                {errors.grading && (
                  <FormHelperText>{errors.grading}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Subjects */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Subjects*
              </Typography>

              <Box
                sx={{
                  background: "white",
                  padding: 2,
                  borderRadius: "10px",
                  border: errors.subjects ? "1px solid #d32f2f" : "none",
                }}
              >
                {subjectsList.length > 0 &&
                  subjectsList.map((subject) => (
                    <FormControlLabel
                      key={subject}
                      control={
                        <Checkbox
                          checked={(data.subjects || []).includes(subject)}
                          onChange={() => toggleSubject(subject)}
                        />
                      }
                      label={subject}
                    />
                  ))}

                {errors.subjects && (
                  <Typography sx={{ color: "#d32f2f", mt: 1, fontSize: 13 }}>
                    {errors.subjects}
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Other subject */}
            {data.subjects?.includes("Others") && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter other subject"
                  sx={uiFieldStyles}
                  error={!!errors.other_subject}
                  helperText={errors.other_subject}
                  value={data.other_subject || ""}
                  onChange={(e) =>
                    setData({ ...data, other_subject: e.target.value })
                  }
                />
              </Grid>
            )}

            {/* Marks */}
            {subjectsList
              .filter((s) => (data.subjects || []).includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Select Marks for {subject} (Class 11)
                  </Typography>

                  <RadioGroup
                    value={data.marks?.["11"]?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("11", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>

                  {errors[`marks11_${subject}`] && (
                    <Typography sx={{ color: "#d32f2f", fontSize: 13 }}>
                      {errors[`marks11_${subject}`]}
                    </Typography>
                  )}
                </Grid>
              ))}
          </Grid>
        </Box>
      )}

      {/* ---------------- CLASS 12 ---------------- */}
      {["12"].includes(selectedClasses) && (
        <Box>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 3 }}>
            Class 12th
          </Typography>

          <Grid container spacing={3}>
            {/* School Name */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Name*
              </Typography>
              <TextField
                fullWidth
                placeholder="School Name"
                sx={uiFieldStyles}
                error={!!errors.school12}
                helperText={errors.school12}
                value={data.school12 || ""}
                onChange={(e) => setData({ ...data, school12: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Board*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.board11}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.board12 || ""}
                  onChange={(e) =>
                    setData({ ...data, board12: e.target.value })
                  }
                >
                  <MenuItem value="" disabled>
                    Select Board
                  </MenuItem>
                  {schoolBoards.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                {errors.board11 && (
                  <FormHelperText>{errors.board11}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Stream */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Stream*
              </Typography>
              <FormControl fullWidth sx={uiFieldStyles} error={!!errors.stream}>
                <Select
                  displayEmpty
                  value={data.stream || ""}
                  onChange={(e) => setData({ ...data, stream: e.target.value })}
                >
                  <MenuItem value="" disabled>
                    Select Stream
                  </MenuItem>
                  {streams.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.stream}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Grading System*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.grading}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.grading || ""}
                  onChange={(e) =>
                    setData({ ...data, grading: e.target.value })
                  }
                >
                  <MenuItem value="" disabled>
                    Choose option
                  </MenuItem>
                  {gradingOptions.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
                {errors.grading && (
                  <FormHelperText>{errors.grading}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Subjects */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Subjects*
              </Typography>

              <Box
                sx={{
                  background: "white",
                  padding: 2,
                  borderRadius: "10px",
                  border: errors.subjects ? "1px solid #d32f2f" : "none",
                }}
              >
                {subjectsList.length > 0 &&
                  subjectsList.map((subject) => (
                    <FormControlLabel
                      key={subject}
                      control={
                        <Checkbox
                          checked={(data.subjects || []).includes(subject)}
                          onChange={() => toggleSubject(subject)}
                        />
                      }
                      label={subject}
                    />
                  ))}

                {errors.subjects && (
                  <Typography sx={{ color: "#d32f2f", mt: 1, fontSize: 13 }}>
                    {errors.subjects}
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Marks */}
            {subjectsList
              .filter((s) => (data.subjects || []).includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Select Marks for {subject} (Class 12)
                  </Typography>

                  <RadioGroup
                    value={data.marks?.["12"]?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("12", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>

                  {errors[`marks12_${subject}`] && (
                    <Typography sx={{ color: "#d32f2f", fontSize: 13 }}>
                      {errors[`marks12_${subject}`]}
                    </Typography>
                  )}
                </Grid>
              ))}
          </Grid>
        </Box>
      )}

      {selectedClasses === "both" && currentStep === "11" && (
        // 👉 Class 11 block (unchanged)
        <Box sx={{ mb: 6 }}>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 3 }}>
            Class 11th
          </Typography>

          <Grid container spacing={3}>
            {/* School Name */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Name*
              </Typography>
              <TextField
                fullWidth
                error={!!errors.school11}
                helperText={errors.school11}
                placeholder="School Name"
                sx={uiFieldStyles}
                value={data.school11 || ""}
                onChange={(e) => setData({ ...data, school11: e.target.value })}
              />
            </Grid>

            {/* Board */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Board*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.board11}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.board11 || ""}
                  onChange={(e) => {
                    setData({ ...data, board11: e.target.value, stream: "" });
                    setStreams(
                      Object.keys(seniorSecondaryBoards[e.target.value]),
                    );
                    // setSameAs11(false);
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Board
                  </MenuItem>
                  {schoolBoards.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                {errors.board11 && (
                  <FormHelperText>{errors.board11}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Stream */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Stream*
              </Typography>
              <FormControl fullWidth sx={uiFieldStyles} error={!!errors.stream}>
                <Select
                  displayEmpty
                  value={data.stream || ""}
                  onChange={(e) => setData({ ...data, stream: e.target.value })}
                >
                  <MenuItem value="" disabled>
                    Select Stream
                  </MenuItem>
                  {streams.map((b) => (
                    <MenuItem key={b} value={b}>
                      {b}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.stream}</FormHelperText>
              </FormControl>
            </Grid>

            {/* Grading */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Grading System*
              </Typography>
              <FormControl
                fullWidth
                error={!!errors.grading}
                sx={uiFieldStyles}
              >
                <Select
                  displayEmpty
                  value={data.grading || ""}
                  onChange={(e) =>
                    setData({ ...data, grading: e.target.value })
                  }
                >
                  <MenuItem value="" disabled>
                    Choose option
                  </MenuItem>
                  {gradingOptions.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
                {errors.grading && (
                  <FormHelperText>{errors.grading}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* Subjects */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Subjects*
              </Typography>

              <Box
                sx={{
                  background: "white",
                  padding: 2,
                  borderRadius: "10px",
                  border: errors.subjects ? "1px solid #d32f2f" : "none",
                }}
              >
                {subjectsList.length > 0 &&
                  subjectsList.map((subject) => (
                    <FormControlLabel
                      key={subject}
                      control={
                        <Checkbox
                          checked={(data.subjects || []).includes(subject)}
                          onChange={() => toggleSubject(subject)}
                        />
                      }
                      label={subject}
                    />
                  ))}

                {errors.subjects && (
                  <Typography sx={{ color: "#d32f2f", mt: 1, fontSize: 13 }}>
                    {errors.subjects}
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Other subject */}
            {data.subjects?.includes("Others") && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter other subject"
                  sx={uiFieldStyles}
                  error={!!errors.other_subject}
                  helperText={errors.other_subject}
                  value={data.other_subject || ""}
                  onChange={(e) =>
                    setData({ ...data, other_subject: e.target.value })
                  }
                />
              </Grid>
            )}

            {/* Marks */}
            {subjectsList
              .filter((s) => (data.subjects || []).includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Select Marks for {subject} (Class 11)
                  </Typography>

                  <RadioGroup
                    value={data.marks?.["11"]?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("11", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>

                  {errors[`marks11_${subject}`] && (
                    <Typography sx={{ color: "#d32f2f", fontSize: 13 }}>
                      {errors[`marks11_${subject}`]}
                    </Typography>
                  )}
                </Grid>
              ))}
          </Grid>
          {selectedClasses === "both" && currentStep === "11" && (
            <Button
              variant="contained"
              sx={{ mt: 4 }}
              onClick={() => setCurrentStep("12")}
            >
              Continue to Class 12
            </Button>
          )}
        </Box>
      )}

      {selectedClasses === "both" && currentStep === "12" && (
        // 👉 Class 12 block
        <Box>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, mb: 3 }}>
            Class 12th
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={sameAs11}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSameAs11(checked);

                  if (checked) {
                    setData((prev) => ({
                      ...prev,
                      school12: prev.school11,
                      board12: prev.board11,
                      stream: prev.stream,
                      grading: prev.grading,
                      subjects: prev.subjects,
                      other_subject: prev.other_subject,
                      // ❌ marks NOT copied
                    }));
                  }
                }}
              />
            }
            label="Same info as Class 11"
          />

          <Grid container spacing={3}>
            {/* School Name */}
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                School Name*
              </Typography>
              <TextField
                fullWidth
                placeholder="School Name"
                disabled={sameAs11}
                sx={uiFieldStyles}
                error={!!errors.school12}
                helperText={errors.school12}
                value={data.school12 || ""}
                onChange={(e) => setData({ ...data, school12: e.target.value })}
              />
            </Grid>

            {/* Marks */}
            {subjectsList
              .filter((s) => (data.subjects || []).includes(s))
              .map((subject) => (
                <Grid item xs={12} key={subject}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Select Marks for {subject} (Class 12)
                  </Typography>

                  <RadioGroup
                    value={data.marks?.["12"]?.[subject] || ""}
                    onChange={(e) =>
                      handleMarksChange("12", subject, e.target.value)
                    }
                  >
                    {getMarksOptions().map((m) => (
                      <FormControlLabel
                        key={m}
                        value={m}
                        control={<Radio />}
                        label={m}
                      />
                    ))}
                  </RadioGroup>

                  {errors[`marks12_${subject}`] && (
                    <Typography sx={{ color: "#d32f2f", fontSize: 13 }}>
                      {errors[`marks12_${subject}`]}
                    </Typography>
                  )}
                </Grid>
              ))}
          </Grid>
          <Button
            variant="contained"
            sx={{ mt: 4 }}
            onClick={() => setCurrentStep("11")}
          >
            Back to Class 11
          </Button>
        </Box>
      )}

      {/* Buttons */}
      <Grid
        container
        spacing={3}
        mt={5}
        display="flex"
        justifyContent="space-between"
      >
        <Grid item>
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              borderColor: "#2C2C2C",
              color: "#2C2C2C",
              padding: "6px 28px",
            }}
          >
            Back
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            onClick={() => handleNextClick(data)}
            sx={{
              backgroundColor: "#2C2C2C",
              color: "white",
              padding: "6px 28px",
              "&:hover": { backgroundColor: "#444" },
            }}
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SchoolingStep1112;
